/**
 * postData.ts — Key lines extracted from 20 posts (May 16-20, 2026)
 * Each post → 4-6 impactful lines para TextReel
 * Formato: {id, badge, style, lines[]}
 */

import {TextLine, TextReelStyle} from "./TextReel";

export interface PostReelData {
  id: string;
  compositionId: string;
  badge: string;
  style: TextReelStyle;
  lines: TextLine[];
}

export const POST_REELS: PostReelData[] = [

  // ─── MAIO 16 ──────────────────────────────────────────────────────

  {
    id: "cmpostcaferoiv16a1",
    compositionId: "CafeEp15",
    badge: "EP15",
    style: "cafe",
    lines: [
      {text: "Marketing sem número é opinião.", isHook: true},
      {text: "E opinião não paga funcionário.", isEmphasis: true},
      {text: "72% das empresas não conseguem medir ROI de marketing.", isEmphasis: true},
      {text: "7 em cada 10 donos investem sem saber o que está voltando.", isPause: false},
      {text: "Você não está gerenciando.", isPause: false},
      {text: "Está torcendo.", isEmphasis: true},
    ],
  },

  {
    id: "verdades-01-0516",
    compositionId: "VerdadesD1",
    badge: "VD#1",
    style: "verdades",
    lines: [
      {text: "O relatório da sua agência foi feito pra você não perguntar sobre vendas.", isHook: true},
      {text: "Não é conspiração.", isPause: false},
      {text: "É incentivo.", isEmphasis: true},
      {text: "Ela faturou quando entregou o post. Não quando você vendeu.", isPause: false},
      {text: "Tudo real. Nada disso paga o seu boleto.", isEmphasis: true},
    ],
  },

  {
    id: "aprendi-01-0516",
    compositionId: "AprendiD1",
    badge: "AE#1",
    style: "aprendi",
    lines: [
      {text: "Minha maior confusão foi achar que mais verba resolvia.", isHook: true},
      {text: "Aumentei o orçamento. O resultado piorou proporcionalmente.", isPause: false},
      {text: "O problema não era o canal.", isEmphasis: true},
      {text: "Era a oferta.", isEmphasis: true},
      {text: "Mais tráfego não vende oferta ruim. Só queima mais rápido.", isPause: false},
    ],
  },

  // ─── MAIO 17 ──────────────────────────────────────────────────────

  {
    id: "cafe-ep16-0517",
    compositionId: "CafeEp16",
    badge: "EP16",
    style: "cafe",
    lines: [
      {text: "Criativo não é arte.", isHook: true},
      {text: "É argumento.", isEmphasis: true},
      {text: "85% dos vídeos são assistidos sem som.", isEmphasis: true},
      {text: "O usuário passa 1,7 segundo por conteúdo.", isPause: false},
      {text: "Bonito não converte.", isPause: false},
      {text: "Precisa ser claro.", isEmphasis: true},
    ],
  },

  {
    id: "verdades-02-0517",
    compositionId: "VerdadesD2",
    badge: "VD#2",
    style: "verdades",
    lines: [
      {text: "O profissional que apresentou a proposta não vai trabalhar na sua conta.", isHook: true},
      {text: "Sênior faz pitch.", isPause: false},
      {text: "Júnior executa.", isEmphasis: true},
      {text: "47% do investimento é desperdiçado por atribuição ruim.", isEmphasis: true},
      {text: "Pergunta antes de assinar: quem toca minha conta no dia a dia?", isPause: false},
    ],
  },

  {
    id: "aprendi-02-0517",
    compositionId: "AprendiD2",
    badge: "AE#2",
    style: "aprendi",
    lines: [
      {text: "Aprendi que agência nova com briefing errado é o mesmo resultado.", isHook: true},
      {text: "Troquei 3 agências. Mesmo problema.", isEmphasis: true},
      {text: "O ciclo só parou quando entendi:", isPause: false},
      {text: "o problema não era quem executava.", isEmphasis: true},
      {text: "Era o que eu estava pedindo pra executar.", isPause: false},
    ],
  },

  {
    id: "perguntas-02-0517",
    compositionId: "AudienceT29",
    badge: "T29",
    style: "audience",
    lines: [
      {text: "Seu maior problema de marketing não é falta de tráfego.", isHook: true},
      {text: "Meta Ads ficou 12% mais caro em 2026.", isEmphasis: true},
      {text: "CAC no e-commerce subiu 60% em 5 anos.", isEmphasis: true},
      {text: "Mais dinheiro no mesmo ciclo quebrado é matemática que piora.", isPause: false},
      {text: "Tráfego não vende oferta ruim.", isEmphasis: true},
      {text: "Corrige a oferta. Depois coloca dinheiro em anúncio.", isPause: false},
    ],
  },

  // ─── MAIO 18 ──────────────────────────────────────────────────────

  {
    id: "cafe-ep17-0518",
    compositionId: "CafeEp17",
    badge: "EP17",
    style: "cafe",
    lines: [
      {text: "Dado sem contexto é só número.", isHook: true},
      {text: "Taxa de conversão de 2% pode ser boa ou catastrófica.", isEmphasis: true},
      {text: "Depende do seu ticket, do seu mercado, do seu ciclo.", isPause: false},
      {text: "Benchmark genérico é muleta.", isEmphasis: true},
      {text: "O número que importa é o seu — comparado ao de ontem.", isPause: false},
    ],
  },

  {
    id: "verdades-03-0518",
    compositionId: "VerdadesD3",
    badge: "VD#3",
    style: "verdades",
    lines: [
      {text: "80% das empresas entram no tráfego pago com oferta fraca.", isHook: true},
      {text: "A agência entrega o técnico.", isPause: false},
      {text: "O problema de conversão não é dela.", isEmphasis: true},
      {text: "Você tem dois problemas simultâneos.", isPause: false},
      {text: "Quem executa não é quem vendeu. E a oferta nunca foi validada.", isEmphasis: true},
    ],
  },

  {
    id: "aprendi-03-0518",
    compositionId: "AprendiD3",
    badge: "AE#3",
    style: "aprendi",
    lines: [
      {text: "No terceiro projeto aprendi a diferença entre atrair e converter.", isHook: true},
      {text: "Todo mês a solução era atrair mais.", isPause: false},
      {text: "Ninguém queria olhar o que acontecia depois que o lead entrava.", isEmphasis: true},
      {text: "Marketing que sangra é bom em atrair e péssimo em converter.", isEmphasis: true},
      {text: "Mais entrada não resolve buraco na saída.", isPause: false},
    ],
  },

  {
    id: "perguntas-03-0518",
    compositionId: "AudienceT04",
    badge: "T04",
    style: "audience",
    lines: [
      {text: "Por que 90% dos donos trocam de agência e ficam no mesmo resultado?", isHook: true},
      {text: "Não é porque a nova agência era ruim.", isPause: false},
      {text: "Você troca de agência carregando o mesmo briefing errado.", isEmphasis: true},
      {text: "Agência nova. Mesmo problema. Resultado idêntico.", isEmphasis: true},
      {text: "A única pergunta que nenhuma agência responde por você:", isPause: false},
      {text: "Por que o meu cliente compra agora — e não amanhã?", isEmphasis: true},
      {text: "Se você não souber responder, nenhuma agência te salva.", isPause: false},
      {text: "Comenta BRIEFING se você já trocou de agência mais de uma vez. ↓", isEmphasis: true},
    ],
  },

  // ─── MAIO 19 ──────────────────────────────────────────────────────

  {
    id: "cafe-ep18-0519",
    compositionId: "CafeEp18",
    badge: "EP18",
    style: "cafe",
    lines: [
      {text: "Funil não é estratégia.", isHook: true},
      {text: "É diagnóstico.", isEmphasis: true},
      {text: "Onde você está perdendo dinheiro agora?", isPause: false},
      {text: "No topo? No meio? No fechamento?", isEmphasis: true},
      {text: "A maioria dos donos não consegue responder.", isPause: false},
      {text: "Cada etapa quebrada tem um custo real e invisível.", isEmphasis: true},
      {text: "Sem número, você não gerencia o funil. Você torce.", isPause: false},
      {text: "Salva esse reel. ☕ Na próxima reunião de funil você vai querer lembrar disso.", isEmphasis: true},
    ],
  },

  {
    id: "verdades-04-0519",
    compositionId: "VerdadesD4",
    badge: "VD#4",
    style: "verdades",
    lines: [
      {text: "A maioria dos contratos de agência protege a agência, não você.", isHook: true},
      {text: "Entregável: posts publicados.", isPause: false},
      {text: "Não: clientes fechados.", isEmphasis: true},
      {text: "Você paga pelo esforço.", isPause: false},
      {text: "A agência fatura pelo entregável.", isEmphasis: true},
      {text: "Resultado para o seu negócio não está no contrato.", isPause: false},
      {text: "Esses dois fatos coexistem perfeitamente.", isEmphasis: true},
      {text: "Comenta CONTRATO se o seu acordo de agência não tem meta de resultado. ↓", isEmphasis: true},
    ],
  },

  {
    id: "aprendi-04-0519",
    compositionId: "AprendiD4",
    badge: "AE#4",
    style: "aprendi",
    lines: [
      {text: "Aprendi que dado sem decisão é decoração de dashboard.", isHook: true},
      {text: "Tínhamos planilha linda.", isPause: false},
      {text: "Reunião toda semana para revisar os números.", isPause: false},
      {text: "Ninguém sabia o que mudar quando os números caíam.", isEmphasis: true},
      {text: "Porque nenhum dado estava conectado a uma ação específica.", isPause: false},
      {text: "Métrica sem decisão não é métrica. É paisagem.", isEmphasis: true},
      {text: "Salva esse reel. 📌 Pra mostrar quando alguém trouxer relatório sem ação atrelada.", isEmphasis: true},
    ],
  },

  {
    id: "perguntas-04-0519",
    compositionId: "AudienceT22",
    badge: "T22",
    style: "audience",
    lines: [
      {text: "5 sinais de que você gerencia marketing por achismo.", isHook: true},
      {text: "1. Diz 'está funcionando' sem saber o custo por lead.", isEmphasis: true},
      {text: "2. Avalia criativo pelo visual, não pelo número.", isEmphasis: true},
      {text: "3. Não sabe de onde veio o último cliente.", isEmphasis: true},
      {text: "4. Confunde volume de atividade com resultado.", isPause: false},
      {text: "5. Nunca cancelou campanha baseado em dado.", isEmphasis: true},
      {text: "Dois ou mais? Você acompanha. Não gerencia.", isPause: false},
      {text: "Comenta quantos você marcou. 1? 2? 3? 4? 5? ↓", isEmphasis: true},
    ],
  },

  // ─── MAIO 20 ──────────────────────────────────────────────────────

  {
    id: "cafe-ep19-0520",
    compositionId: "CafeEp19",
    badge: "EP19",
    style: "cafe",
    lines: [
      {text: "Previsibilidade é o único luxo real que um dono tem.", isHook: true},
      {text: "A maioria começa o mês sem saber quanto vai custar cada cliente.", isPause: false},
      {text: "Sem saber qual canal funciona. Sem saber onde o dinheiro para.", isEmphasis: true},
      {text: "Então torce.", isPause: false},
      {text: "Saber o custo de aquisição.", isEmphasis: true},
      {text: "Saber qual canal traz retorno real.", isEmphasis: true},
      {text: "Saber onde o dinheiro para de funcionar.", isEmphasis: true},
      {text: "Isso não é intuição. É sistema.", isEmphasis: true},
      {text: "Segue @guilhermeribeiro.ai — quinta tem o sistema completo. ☕", isEmphasis: true},
    ],
  },

  {
    id: "verdades-05-0520",
    compositionId: "VerdadesD5",
    badge: "VD#5",
    style: "verdades",
    lines: [
      {text: "Crescimento de seguidores não é indicador de negócio.", isHook: true},
      {text: "Seguidores não pagam aluguel.", isEmphasis: true},
      {text: "Mas é o número que mais aparece na reunião mensal.", isPause: false},
      {text: "A pergunta que ninguém faz:", isEmphasis: true},
      {text: "'Quanto de receita foi gerado por essa ação?'", isEmphasis: true},
      {text: "Se a resposta for silêncio, você não tem dado de resultado.", isPause: false},
      {text: "Você tem relatório de vaidade.", isEmphasis: true},
      {text: "Comenta o que sua agência apresenta na reunião mensal. ↓", isEmphasis: true},
    ],
  },

  {
    id: "aprendi-05-0520",
    compositionId: "AprendiD5",
    badge: "AE#5",
    style: "aprendi",
    lines: [
      {text: "O maior erro que cometi foi confundir movimentação com progresso.", isHook: true},
      {text: "Postar todo dia.", isPause: false},
      {text: "Responder todo comentário.", isPause: false},
      {text: "Reunião semanal de revisão.", isPause: false},
      {text: "Parecia trabalho de marketing. Era ritualística.", isEmphasis: true},
      {text: "Resultado? Nenhum atribuível a nada específico.", isEmphasis: true},
      {text: "Processo sem métrica não é disciplina. É religião.", isEmphasis: true},
      {text: "Salva e manda pra quem confunde ocupado com produtivo. 📌", isEmphasis: true},
    ],
  },

  {
    id: "perguntas-05-0520",
    compositionId: "AudienceT08",
    badge: "T08",
    style: "audience",
    lines: [
      {text: "6 projetos. A mesma pergunta errada. Até o sexto.", isHook: true},
      {text: "No primeiro: mais verba. Resultado piorou.", isPause: false},
      {text: "No terceiro: nova agência. Mesmo custo.", isPause: false},
      {text: "Cinco anos de ciclo quebrado.", isEmphasis: true},
      {text: "No sexto paramos de perguntar como atrair mais.", isPause: false},
      {text: "E perguntamos: por que perdemos os que já atraímos?", isEmphasis: true},
      {text: "Custo de aquisição caiu 40% em 90 dias. Sem aumentar um centavo de verba.", isEmphasis: true},
      {text: "Comenta em qual projeto você está. 1? 3? 6? ↓", isEmphasis: true},
    ],
  },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
